export const adminDashboard = {
  'admin.dashboard.title': 'Admin Dashboard',
  'admin.dashboard.subtitle': 'Plattformübersicht und wichtige Kennzahlen',
  'admin.dashboard.totalEarnings.lifetime': 'Gesamte Lebenszeit-Einnahmen',
  'admin.dashboard.totalEarnings.lastMonth': 'Einnahmen des letzten Monats',
  'admin.dashboard.additionalMetrics': 'Zusätzliche Kennzahlen kommen bald',
  'admin.dashboard.charts.accountsProfits': 'Plattform-Gewinnverlauf',
  'admin.dashboard.charts.commissionsOverTime': 'Provisionshistorie',
  'admin.dashboard.charts.totalEarnings': 'Gesamteinnahmen im Zeitverlauf',
  'admin.dashboard.users.title': 'Benutzer Gesamt',
  'admin.dashboard.users.active': 'Aktive Benutzer',
  'admin.dashboard.users.newThisMonth': 'Neue diesen Monat',
  'admin.dashboard.communityValue.title': 'Gesamter Community-Wert',
  'admin.dashboard.communityValue.description': 'Kombinierter Wert aller Benutzerkonten',
  'admin.dashboard.totalEarnings.accountProfit': 'Kontogewinn',
  'admin.dashboard.totalEarnings.commissionProfit': 'Provisionsgewinn',
  'admin.dashboard.totalEarnings.description': 'Kombinierte Plattform-Einnahmen bis heute',
  'admin.dashboard.lastMonthEarnings.description': 'Plattform-Einnahmen für',
};